import { Text, type TextProps } from '@mantine/core';
import { eyebrowStyle } from '../theme';

/** Mono verzálky — popisková řeč mapy: legendy, kódy, jednotky. */
export function Eyebrow({ children, style, ...rest }: TextProps & { children: React.ReactNode }) {
  return (
    <Text component="span" c="dimmed" style={{ ...eyebrowStyle, ...style }} {...rest}>
      {children}
    </Text>
  );
}
